import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/api";
import { useLang } from "../context/LanguageContext";

export const WhatsAppFloat = () => {
  const { lang } = useLang();
  const msg = lang === "ms"
    ? "Hai, saya berminat dengan perkhidmatan doktor lawatan rumah anda."
    : "Hi, I'm interested in your home visit doctor services.";
  return (
    <a href={waLink(msg)} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-white px-4 py-3.5 rounded-full shadow-lg hover:scale-105 transition-transform">
      <MessageCircle className="w-6 h-6" />
      <span className="hidden sm:inline font-semibold text-sm">WhatsApp</span>
    </a>
  );
};
